import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconThumbUpCurved: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconThumbUpCurved"><Path d="M12.3702 1.91357L12.0773 2.6146C11 6.5 8 8.55499 8 11.2699V17.7252C8 18.8716 8.66361 20.0005 9.83559 20.4272C12.4864 21.3925 14.2335 21.589 16.9595 21.3527C19.0504 21.1715 20.6221 19.5685 21.0577 17.6326L21.9024 13.8781C22.4651 11.3773 20.5633 9.00005 18 9.00005L15 9C15.5 6 16.7679 2.46329 12.3702 1.91357Z" fill="currentColor"/><Path d="M2 9.5H7V20.5H2V9.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconThumbUpCurved;
